import { render, staticRenderFns } from "./IpManage.vue?vue&type=template&id=24d57e81&scoped=true"
import script from "./IpManage.vue?vue&type=script&lang=js"
export * from "./IpManage.vue?vue&type=script&lang=js"
import style0 from "./IpManage.vue?vue&type=style&index=0&id=24d57e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d57e81",
  null
  
)

export default component.exports